export default __webpack_public_path__ + "static/media/detail_small_2_5.6839351a.png";